export default __webpack_public_path__ + "static/media/LarryLarp.9b55e43b.webp";